import { Component, OnInit, Input, EventEmitter, Optional, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { WalletService } from '../../services/wallet/wallet.service';
import { movieVM } from '../../models/movieVM';
import { SelectItem } from 'primeng/components/common/api';
import { Message } from 'primeng/components/common/api';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html'
})
export class WalletComponent implements OnInit {
  constructor(private _walletService: WalletService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.route.queryParams.subscribe(params => {
      debugger;
      this.userId = params['userId'];
    });
  }
  isLoading: boolean = false;
  msgs: Message[] = [];
  model: any = {};
  user: any = {};
  user$ = new Subject<any>();
  userId: any = "";
  isAddEditShow: boolean = false;

  ngOnInit() {
    debugger;
    if (this.userId != "" && this.userId != undefined) {
      this.myWallet(this.userId);
    }
    else {
      this.bindWallets();
    }
  }

  myWallet(userId: string) {
    this._walletService.getMyWallet(userId).subscribe(res => {
      debugger;
      this.isLoading = false;
      this.isAddEditShow = true;
      this.model = res.data;
    }, error => {
      this.isLoading = false;
      this.msgs.push({ severity: 'error', summary: 'Error', detail: error })
      this.hideMessage();
    });
  }

  bindWallets() {
    this._walletService.getAll().subscribe(res => {
      this.isLoading = false;
      setTimeout(() => {
        this.user = res.data;
        this.user$.next(res.data);
      }, 100);
    }, error => {
      this.isLoading = false;
      this.msgs.push({ severity: 'error', summary: 'Error', detail: error })
      this.hideMessage();
    });
  }

  onSubmit(f: any) {
    this.isLoading = true;
    this._walletService.getAll().subscribe(data => {
      debugger;
      this.isLoading = false;
      this.user = data;
      localStorage.setItem("currentUser", this.user.userToken)
      this.router.navigate(['/dashboard/movies'])
    }, error => {
      this.isLoading = false;
      this.msgs.push({ severity: 'error', summary: 'Error', detail: error })
      this.hideMessage();
    });
  }

  hideMessage() {
    setTimeout(() => {
      this.msgs = [];
    }, 3000);
  }

}





// WEBPACK FOOTER //
// ./src/app/components/wallet/wallet.component.ts